export default "__VITE_ASSET__CiisEwjI__"